'use strict';

var React = require('react');

var SvgTransferOutMajor = function SvgTransferOutMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m4.414 13 1.293 1.293a1 1 0 1 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 1.414l-1.293 1.293h6.586a1 1 0 0 1 0 2h-6.586zm14.586 5.5a1.5 1.5 0 0 1-1.5 1.5h-15.214c-.71 0-1.286-.576-1.286-1.286v-.714a1 1 0 1 1 2 0h14v-12.382l-7-3.5-7 3.5v.382a1 1 0 0 1-2 0v-1c0-.379.214-.725.553-.895l8-4c.281-.14.613-.14.894 0l8 4c.339.17.553.516.553.895v13.5z"
  }));
};

exports.SvgTransferOutMajor = SvgTransferOutMajor;
